/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';


function NumberCodes() {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [names, setNames] = useState(null);
  const [specifiers, setSpecifiers] = useState(null);

  const loadBetCodes = async () => {
    const data = await dispatch.events.getBetCodes(4);
    setSpecifiers(data.specifiers);
    setData(data);
    setNames(data.names);
  };

  useEffect(() => {
    loadBetCodes();
  }, []);

  return (
    <>
      <>
        <thead className="type-codes__header">
          <div className="type-code__table-title"> Coupon Codes</div>
          <tr>
            <th className="type-codes__first-row">{ t('numbers.ballsMarkets') }</th>
            {
              _.map(names, (name, index) => {
                return (
                  <th key={ index }>{ name.name }</th>
                );
              })
            }
          </tr>
        </thead>
        <tbody>
          {
            data &&
          _.map(specifiers, (specifier, index) => {
            const bonus = _.find(data.bonusMarkets, { specifier });
            const regular = _.find(data.regularMarkets, { specifier });
            const plusBonus1 = _.find(data.mainPlusBonusMarkets, { specifier, specifier2:'1' });
            const plusBonus2 = _.find(data.mainPlusBonusMarkets, { specifier, specifier2:'2' });
            const plusBonus3 = _.find(data.mainPlusBonusMarkets, { specifier, specifier2:'x' });
            const bonusRegular = _.find(data.bonusRegularMarkets, { specifier });

            return (
              <tr className="type-codes__rows" key={ index }>
                <td>
                  { +specifier === 1 ? t('numbers.ball_one', { count: +specifier }) : t('numbers.ball_other', { count: specifier }) }
                </td>
                <td>{ regular?.code }</td>
                <td>{ bonusRegular?.code }</td>
                <td>{ bonus?.code }</td>
                <td>{ plusBonus1?.code }</td>
                <td>{ plusBonus2?.code }</td>
                <td>{ plusBonus3?.code }</td>
              </tr>
            );
          })
          }
        </tbody>
      </>
      <>
        <thead className="type-codes__header">
          <br />
          <div className="type-code__table-title">Card Codes</div>
          <tr>
            <th className="type-codes__first-row">{ t('numbers.ballsMarkets') }</th>
            {
              _.map(names, (name, index) => {
                return (
                  <th key={ index }>{ name.name }</th>
                );
              })
            }
          </tr>
        </thead>
        <tbody>
          {
            data &&
        _.map(specifiers, (specifier, index) => {
          const bonus = _.find(data.bonusMarkets, { specifier });
          const regular = _.find(data.regularMarkets, { specifier });
          const plusBonus1 = _.find(data.mainPlusBonusMarkets, { specifier, specifier2:'1' });
          const plusBonus2 = _.find(data.mainPlusBonusMarkets, { specifier, specifier2:'2' });
          const plusBonus3 = _.find(data.mainPlusBonusMarkets, { specifier, specifier2:'x' });
          const bonusRegular = _.find(data.bonusRegularMarkets, { specifier });

          return (
            <tr className="type-codes__rows" key={ index }>
              <td>
                { +specifier === 1 ? t('numbers.ball_one', { count: +specifier }) : t('numbers.ball_other', { count: specifier }) }
              </td>
              <td>{ regular?.cardCode }</td>
              <td>{ bonusRegular?.cardCode }</td>
              <td>{ bonus?.cardCode }</td>
              <td>{ plusBonus1?.cardCode }</td>
              <td>{ plusBonus2?.cardCode }</td>
              <td>{ plusBonus3?.cardCode }</td>
            </tr>
          );
        })
          }
        </tbody>
      </>
    </>
  );
}

export default NumberCodes;
